
<h1 class="main-title"><span class="thin">Dealer</span> Curator ADMIN</h1>

<form (ngSubmit)="login()" aria-labelledby="sub-title">
  <button nbButton fullWidth status="danger" size="large" [nbSpinner]="loading" nbSpinnerStatus="success"
          [class.btn-pulse]="submitted">
    Log In with Google
  </button>
</form>
